export const VEHICLES_TYPES = [
    {
        value: 0,
        measured: null,
        name: "Desconhecido"
    },
    {
        value: 1,
        measured: "Tractor",
        name: "Trator"
    },
    {
        value: 2,
        measured: "Harvester",
        name: "Colhedora"
    },
    {
        value: 3,
        measured: "Harvester",
        name: "Colheitadeira"
    },
    {
        value: 4,
        measured: "Sprayer",
        name: "Pulverizador"
    },
    {
        value: 5,
        measured: "Sprayer",
        name: "Distribuidor"
    },
    {
        value: 6,
        measured: "Harvester",
        name: "Forrageira"
    },
    {
        value: 7,
        measured: null,
        name: "Escavadeira"
    },
    {
        value: 8,
        measured: null,
        name: "Pá Carregadeira"
    },
    {
        value: 9,
        measured: null,
        name: "Caminhão"
    },
    {
        value: 10,
        measured: null,
        name: "Carregadeira"
    },
    {
        value: 11,
        measured: null,
        name: "Motoniveladora"
    },
    {
        value: 12,
        measured: null,
        name: "Transportadora"
    },
    {
        value: 13,
        measured: null,
        name: "Colhedora Florestal"
    },
    {
        value: 14,
        measured: null,
        name: "Harverster"
    },
    {
        value: 15,
        measured: null,
        name: "Forwarder"
    },
    {
        value: 16,
        measured: null,
        name: "Feller Buncher"
    },
    {
        value: 17,
        measured: null,
        name: "Outro"
    },
    {
        value: 18,
        measured: "Sprayer",
        name: "Semeadora pneumática"
    },
    {
        value: 19,
        measured: null,
        name: "Retroescavadeira"
    },
    {
        value: 20,
        measured: null,
        name: "Espargidor de Agente Aglutinante"
    },
    {
        value: 21,
        measured: null,
        name: "Compactador"
    },
    {
        value: 22,
        measured: null,
        name: "Cultivador"
    },
    {
        value: 23,
        measured: null,
        name: "Guindaste"
    },
    {
        value: 24,
        measured: null,
        name: "Máquina Florestal"
    },
    {
        value: 25,
        measured: null,
        name: "Empilhadeira"
    },
    {
        value: 26,
        measured: null,
        name: "Caminhonete"
    },
    {
        value: 27,
        measured: null,
        name: "Rolo pneumático"
    },
    {
        value: 28,
        measured: null,
        name: "Pavimentadora de Estradas"
    },
    {
        value: 29,
        measured: null,
        name: "Skidder"
    },
    {
        value: 30,
        measured: null,
        name: "Veículos Utilitários"
    },
    {
        value: 31,
        measured: null,
        name: "Enfardadeira"
    },
    {
        value: 32,
        measured: null,
        name: "Caminhão Comboio"
    },
    {
        value: 33,
        measured: null,
        name: "Plataforma"
    }
]

export const MOVEMENT_SYSTEMS = [
    {
        name: 'Sobre rodas',
        value: 'wheeled',
        code: 0
    },
    {
        name: 'Sobre esteiras',
        value: 'tracked',
        code: 1
    },
    {
        name: 'Articulado',
        value: 'articulated',
        code: 2
    }
]

export const X_AXIS_POSITIONS = [
    {
        name: 'Frente',
        code: 'front',
        multiplier: 10
    },
    {
        name: 'Centro',
        code: 'middle',
        multiplier: 0
    },
    {
        name: 'Atrás',
        code: 'back',
        multiplier: -10
    }
]

export const Y_AXIS_POSITIONS = [
    {
        name: 'Direita',
        code: 'right',
        multiplier: 10
    },
    {
        name: 'Centro',
        code: 'middle',
        multiplier: 0
    },
    {
        name: 'Esquerda',
        code: 'left',
        multiplier: -10
    }
]

export const CONNECTOR_POSITIONS = [
    {
        name: 'Frontal',
        code: 'front',
        multiplier: 10
    },
    {
        name: 'Traseiro',
        code: 'back',
        multiplier: -10
    }
]

export const CONNECTOR_TYPES = [
    {
        id: 0,
        name: "Desconhecido"
    },
    {
        id: 1,
        name: "Barra de Tração"
    },
    {
        id: 2,
        name: "Engate de Três Pontos Semimontados"
    },
    {
        id: 3,
        name: "Engate de Três Pontos Montado"
    },
    {
        id: 4,
        name: "Gancho"
    },
    {
        id: 5,
        name: "Forquilha"
    },
    {
        id: 6,
        name: "Piton"
    },
    {
        id: 7,
        name: "Engate CUNA"
    },
    {
        id: 8,
        name: "Esfera"
    },
    {
        id: 9,
        name: "Montado no Chassi"
    },
    {
        id: 10,
        name: "Engate de Vagão"
    }
]

export const DEFAULT_CONNECTOR_VALUES = [
    {
        type: {
            id: 0,
            name: 'Desconhecido'
        },
        position: {
            name: 'Traseiro',
            code: 'back',
            multiplier: -10
        },
        distance: 100,
        default: true
    },
    {
        type: {
            id: 1,
            name: 'Barra de Tração'
        },
        position: {
            name: 'Traseiro',
            code: 'back',
            multiplier: -10
        },
        distance: 100,
        default: true
    },
    {
        type: {
            id: 2,
            name: 'Engate de Três Pontos Semimontados'
        },
        position: {
            name: 'Traseiro',
            code: 'back',
            multiplier: -10
        },
        distance: 120,
        default: true
    },
    {
        type: {
            id: 3,
            name: 'Engate de Três Pontos Montado'
        },
        position: {
            name: 'Frontal',
            code: 'front',
            multiplier: 10
        },
        distance: 300,
        default: true
    },
    {
        type: {
            id: 3,
            name: 'Engate de Três Pontos Montado'
        },
        position: {
            name: 'Traseiro',
            code: 'back',
            multiplier: -10
        },
        distance: 100,
        default: true
    },
    {
        type: {
            id: 4,
            name: 'Gancho'
        },
        position: {
            name: 'Traseiro',
            code: 'back',
            multiplier: -10
        },
        distance: 100,
        default: true
    },
    {
        type: {
            id: 5,
            name: 'Forquilha'
        },
        position: {
            name: 'Traseiro',
            code: 'back',
            multiplier: -10
        },
        distance: 100,
        default: true
    },
    {
        type: {
            id: 6,
            name: 'Piton'
        },
        position: {
            name: 'Traseiro',
            code: 'back',
            multiplier: -10
        },
        distance: 70,
        default: true
    },
    {
        type: {
            id: 7,
            name: 'Engate CUNA'
        },
        position: {
            name: 'Traseiro',
            code: 'back',
            multiplier: -10
        },
        distance: 100,
        default: true
    },
    {
        type: {
            id: 8,
            name: 'Esfera'
        },
        position: {
            name: 'Traseiro',
            code: 'back',
            multiplier: -10
        },
        distance: 70,
        default: true
    },
    {
        type: {
            id: 9,
            name: 'Montado no Chassi'
        },
        position: {
            name: 'Traseiro',
            code: 'back',
            multiplier: -10
        },
        distance: 0,
        default: true
    },
    {
        type: {
            id: 10,
            name: 'Engate de Vagão'
        },
        position:{
            name: 'Traseiro',
            code: 'back',
            multiplier: -10
        },
        distance: 100,
        default: true
    }
]
